
import { defineComponent } from 'vue';
import RequiredInputEmail from '@/components/RequiredInputsRefactor/RequiredInputEmail.vue';
import RequiredInputPhone from '@/components/RequiredInputsRefactor/RequiredInputPhone.vue';

export default defineComponent({
	name: 'required-input-refactor',

	components: {
		email: RequiredInputEmail,
		phone: RequiredInputPhone
	},

	props: {
		typeOfInput: {
			type: String,
			required: true
		},
		control: {
			type: Object,
			required: true
		},
		displayType: {
			type: String,
			default: 'widget'
		},
		showInvalidRequiredInput: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		// Флаг определяет какой стиль поля отображать узкое или широкое
		dense(): boolean {
			return this.displayType === 'trigger';
		}
	},
	methods: {
		emitChangeControl(control: object) {
			this.$emit('change-control', control);
		}
	},
	emits: ['change-control']
});
